import { SupportedChainId } from '@orionprotocol/sdk';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';

 
import { PoolV3Position } from '../../types';

type LoadableData = {
  isLoading: boolean;
};

export type PoolV3Positions = LoadableData &
  Partial<{
    data: PoolV3Position[];
  }>;

export type PoolsState = {
  v3Positions: PoolV3Positions;
  shouldPoolV3Update: boolean;
};

export type PoolsSliceState = {
  app: {
    chainId: SupportedChainId;
  };
  pools: PoolsState;
};

const initialState: PoolsState = {
  v3Positions: {
    isLoading: false,
    data: undefined,
  },
  shouldPoolV3Update: false,
};

export const poolsSlice = createSlice({
  name: 'pools',
  initialState,
  reducers: {
    setPoolV3Positions(state, action: PayloadAction<Partial<PoolV3Positions>>) {
      state.v3Positions = { ...state.v3Positions, ...action.payload };
    },
    reloadPoolV3Positions(state) {
      state.v3Positions = initialState.v3Positions;
    },

    setShouldPoolV3Update(state, action: PayloadAction<boolean>) {
      state.shouldPoolV3Update = action.payload;
    },
  },
});

export const poolsReducer = poolsSlice.reducer;
